/*
 * @Description:
 * @Date: 2020-11-06 16:31:41
 */
import { moneyFixed } from '@/tools/money';

export default {
  index: {
    width: '100px',
    label: '序号',
    type: 'index'
  },
  projectName: {
    label: '项目名称',
    width: 180,
    prop: 'projectName'
  },
  gongyeName: {
    label: '项目方',
    width: 180,
    prop: 'gongyeName'
  },
  months: {
    showToolTip: false,
    label: '历史参与月度',
    prop: 'months',
    render(h, ctx, row) {
      const taskDts = row.taskDts.split(',').sort((a, b) => {
        return new Date(a) - new Date(b);
      });
      const vm = ctx.parent;
      const jump = month => {
        return () => {
          let query = {
            projectId: row.id,
            fullName: vm.defaultQuery.fullName,
            phone: vm.defaultQuery.phone,
            dateRangeStart: month,
            dateRangeEnd: month,
            isComplete: 2
          };
          vm.$toRecord(query);
        };
      };
      return (
        <div style="text-align:left">
          {taskDts.map(item => {
            return (
              <el-button
                type="text"
                style="margin: 0 10px"
                onClick={jump(item)}
              >
                {item}
              </el-button>
            );
          })}
        </div>
      );
    }
  },
  taskSumSurplus: {
    label: '剩余预采购任务量',
    prop: 'taskSumSurplus',
    render: (h, ctx, row) => {
      return (
        <span>
          {Number.isFinite(row.taskSumSurplus) ? row.taskSumSurplus : '-'}
        </span>
      );
    }
  },
  passingTaskSumPlatform: {
    label: '系统接收中任务量',
    prop: 'passingTaskSumPlatform',
    render: (h, ctx, row) => {
      return (
        <span>
          {Number.isFinite(row.passingTaskSumPlatform)
            ? row.passingTaskSumPlatform
            : '-'}
        </span>
      );
    }
  },
  passTaskSumPlatform: {
    label: '系统已接收任务量',
    prop: 'passTaskSumPlatform',
    render: (h, ctx, row) => {
      return (
        <span>
          {Number.isFinite(row.passTaskSumPlatform)
            ? row.passTaskSumPlatform
            : '-'}
        </span>
      );
    }
  },
  passingTaskSum: {
    label: '待审核任务量',
    prop: 'passingTaskSum',
    render: (h, ctx, row) => {
      return (
        <span>
          {Number.isFinite(row.passingTaskSum) ? row.passingTaskSum : '-'}
        </span>
      );
    }
  },
  userAmount: {
    label: '预计结算服务总价（含税）',
    prop: 'userAmount',
    render: (h, ctx, row) => {
      return <span>{moneyFixed(row.userAmount) || '-'}</span>;
    }
  },
  noFinishTaskSum: {
    label: '未完成任务量',
    prop: 'noFinishTaskSum',
    render: (h, ctx, row) => {
      return (
        <span>
          {Number.isFinite(row.noFinishTaskSum) ? row.noFinishTaskSum : '-'}
        </span>
      );
    }
  },
  prePurchaseProsces: {
    prop: 'finishRate',
    label: '预采购任务量完成进度',
    width: 200,
    render: (h, ctx, row) => {
      const process = row.finishRate;
      return Number.isFinite(process) ? (
        <el-progress stroke-width={10} percentage={process} color={'#FF8B3C'}>
          <span style={{ fontSize: '12px' }}>{process}%</span>
        </el-progress>
      ) : (
        <span>{'-'}</span>
      );
    }
  },
  taskDts: {
    showToolTip: true,
    label: '参与日期',
    prop: 'taskDts',
    width: '210px'
  },
  serviceProjectName: {
    showToolTip: true,
    label: '服务类型',
    prop: 'serviceProjectName',
    width: 150
  },
  isComplete: {
    showToolTip: true,
    label: '执行状态',
    prop: 'isComplete',
    render: (h, ctx, row) => {
      return <span>{{ 0: '执行中', 1: '已完结' }[row.isComplete] || '-'}</span>;
    },
    width: 90
  },
  settledStatus: {
    showToolTip: true,
    label: '项目入驻状态',
    prop: 'settledStatus',
    render: (h, ctx, row) => {
      return (
        <span>
          {{ 0: '未入驻', 1: '已入驻', 2: '已退出' }[row.settledStatus] || '-'}
        </span>
      );
    },
    width: 100
  },
  agentStatus: {
    showToolTip: true,
    label: '项目是否停用',
    prop: 'agentStatus',
    render: (h, ctx, row) => {
      return <span>{{ 1: '否', 2: '是' }[row.agentStatus] || '-'}</span>;
    },
    width: 100
  },
  userTag: {
    showToolTip: true,
    label: '人员标签',
    prop: 'userTag',
    width: 100
  },
  price: {
    showToolTip: true,
    label: '项目结算单价(不含税)',
    prop: 'price',
    render: (h, ctx, row) => {
      if (row.projectType == 19) return <span>-</span>;
      return <span>{moneyFixed(row.price) || '-'}</span>;
    }
  },
  csoPrice: {
    showToolTip: true,
    label: '终端结算单价',
    prop: 'csoPrice',
    render: (h, ctx, row) => {
      if (row.projectType == 19) return <span>-</span>;
      return <span>{moneyFixed(row.csoPrice) || '-'}</span>;
    }
  },
  submitNum: {
    showToolTip: true,
    label: '可结算任务量',
    prop: 'submitNum',
    render: (h, ctx, row) => {
      return (
        <span>{Number.isFinite(row.submitNum) ? row.submitNum : '-'}</span>
      );
    }
  }
};
